import React from 'react';
import PropTypes from 'prop-types';

import {Tooltip} from "@mui/material";

import CopyIcon from "./CopyIcon";
import CopiedIcon from "./CopiedIcon";

import {blue500} from "assets/jss/main";

// trailing characters kept glued to the copy icon (same nowrap unit) so the icon is never
// isolated alone on its own wrapped line when the number exactly fills a line - see
// TrackingNumbers/index.js's estimateLineCount, which reserves the same length
export const ICON_TAIL_LENGTH = 3;

TrackingNumberItem.propTypes = {
    trackingNumber: PropTypes.string.isRequired,
    tooltip: PropTypes.node.isRequired,
    copied: PropTypes.bool,
    onCopy: PropTypes.func.isRequired
};

function TrackingNumberItem({trackingNumber, tooltip, copied = false, onCopy}) {
    const head = trackingNumber.slice(0, -ICON_TAIL_LENGTH);
    const tail = trackingNumber.slice(-ICON_TAIL_LENGTH);

    return (
        <Tooltip title={tooltip}>
            <span style={{color: blue500, fontWeight: 600}}>
                <span style={{display: 'inline-block', maxWidth: '120px', wordBreak: 'break-all', verticalAlign: 'top'}}>
                    {head}
                    <span style={{whiteSpace: 'nowrap'}}>
                        {tail}
                        {copied ? (
                            <CopiedIcon style={{verticalAlign: 'middle', marginLeft: '4px'}} />
                        ) : (
                            <CopyIcon
                                onClick={onCopy}
                                style={{verticalAlign: 'middle', marginLeft: '4px', cursor: 'pointer'}}
                            />
                        )}
                    </span>
                </span>
            </span>
        </Tooltip>
    );
}

export default TrackingNumberItem;
